import Tip from './Tip';
import Tips from './Tips';
export { Tip, Tips };
export * from './interface';
